import { ca } from '@cian/analytics';

import { IPublicWebV1SearchResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';

export const trackOpenDesktopListing = (pageNumber: number, listingOffers?: IPublicWebV1SearchResponse) => {
  const offersPositionOffset = pageNumber ? (pageNumber - 1) * 28 : undefined;
  const hasOffset = offersPositionOffset !== undefined;

  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'ListingHybrid',
      siteType: 'desktop',
    },
    products: listingOffers?.offers.reduce(
      (acc, offer, index) => [
        ...acc,
        {
          id: offer.id,
          position: hasOffset ? index + 1 + offersPositionOffset : undefined,
          offerType: 'offer',
          extra: {
            isPriceWithDiscount: Boolean(offer.discount),
          },
        },
      ],
      [],
    ),
  });
};

export const trackCloseDesktopListing = () => {
  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'Map',
      siteType: 'desktop',
    },
  });
};
